import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { colors } from '@/styles'
import { createModal, useModalize } from '@/components/modalize/mui'
import { Button } from '@/components/button'

const EditNameModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 480px;
  padding: 24px;
  margin: auto;
  box-sizing: border-box;
  border-radius: 16px;
`

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const EditNameModalTitle = styled.div`
  font-family: 'Inter';
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: ${colors.black};
`

const EditNameButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`

const EditNameModalInput = styled.input`
  width: 100%;
  margin: 24px;
  padding: 16px 12px;
  background: ${colors.white};
  border: 1.5px solid ${colors.grey88};
  border-radius: 6px;

  color: ${colors.grey56};
  font-family: 'Inter';
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`

const EditNameModal = ({ packageFile, dispatch, contractId }) => {
  const { close } = useModalize()
  const inputRef = useRef()
  const { t } = useTranslation()
  const [name, setName] = useState(packageFile?.file_original_name)

  const handleEditName = async () => {
    if (inputRef.current.value.length > 0) {
      const response = await dispatch.contract.updateDocumentName({
        packageFileId: packageFile.id,
        contractId: contractId,
        name: inputRef.current.value
      })
      if (response.response.ok) {
        close()
      }
    }
  }

  return (
    <EditNameModalWrapper>
      <TitleWrapper>
        <EditNameModalTitle>
          {t('l.contract.edit_name.document_name.text', 'Edit Document Name')}
        </EditNameModalTitle>
      </TitleWrapper>
      <EditNameModalInput
        ref={inputRef}
        type="text"
        maxLength={100}
        value={name}
        onChange={e => setName(e.target.value)}
      />
      <EditNameButtonWrapper>
        <Button theme="secondary" onClick={close} width="104px" minWidth="unset">
          {t('common.cancel', 'Cancel')}
        </Button>
        <Button onClick={handleEditName} width="104px" minWidth="unset">
          {t('common.save', 'Save')}
        </Button>
      </EditNameButtonWrapper>
    </EditNameModalWrapper>
  )
}

export const showEditNameModal = createModal(EditNameModal, { showClose: false, width: '480px' })
